module.exports = __webpack_public_path__ + "assets/img/d5ddad21275b6383ce7e253b90f45c6f.svg";